import {fromJS, Map} from 'immutable';
import { setTravelWanted, setQuoteWanted, updateTravelSupplement} from './core';

const getInitialState = () => {
     //fromJS(JSON.parse(document.getElementById('booking-process-sidebar__react-anchor').getAttribute('data-initialState')));
    return Map({
        resort: 'Val Thorens',
        accommodation: 'Cybele',
        propertyFeatures: ['Indoor heated pool &amp; jacuzzi', '300m from the resort center', '600m from Olympe cable car'],
        rooms: ['Superior chalet', 'Basic 2-bed apartment'],
        accommodationImage: 'https://source.unsplash.com/1600x900/?snow,ski,mountains,1',
        accolades: ['Director\'s choice', 'Best chalet 2018'],
        accommodationDescription: 'The 3* residence Cybele is situated 300m from the resort centre and 600m from the Olympe cable car (linking Meribel and the 3 Vallées slopes in 25 minutes). It has its own shuttle bus, free to residents, to the gondola. The walk to the resort centre, its shops, casino, bars and restaurants takes 4 minutes.',
        starRating: 3,
        boardBasis: 'Self-catering',
        nights: 7,
        arrivalDate: '7th January 2019',
        departureDate: '14th January 2019',
        accommodationPrice: 950,
        flexiPlus: 'Included',
        noTravelAdjustment: -200,
        inboundTravelSupplement: 0,
        outboundTravelSupplement: 0,
        travelWanted: true
    });
};

const reducer = (state = getInitialState(), action) => {
    switch(action.type) {
        case 'UPDATE_TRAVEL_SUPPLEMENT':
            return updateTravelSupplement(state, action.payload.value, action.payload.direction);
        case 'SET_TRAVEL_WANTED':
        return setTravelWanted(state, action.payload.travelWanted);
      case 'SET_QUOTE_WANTED':
        return setQuoteWanted(state, action.payload.quoteWanted);
    }
    return state;
};

export default reducer;
